//@ts-expect-error https://vitejs.dev/guide/api-plugin#virtual-modules-convention
// https://github.com/originjs/vite-plugin-federation/discussions/193
// eslint-disable-next-line import/no-unresolved
import { __federation_method_getRemote, __federation_method_setRemote } from 'virtual:__federation__';

export const registerDynamicFederation = (remoteName: string, moduleName: string, remoteUrl: string, format = 'var', from = 'webpack') => {
    __federation_method_setRemote(remoteName, {
        url: () => Promise.resolve(remoteUrl),
        format,
        from,
    });
    __federation_method_getRemote(remoteName, moduleName);
};
